/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Sethuram Gautham Rajakumar — AI/ML Engineer & Data Scientist",
  description:
    "AI/ML Engineer and Data Scientist specializing in LLM agents, RAG systems, multi-agent architectures, and privacy-first local AI infrastructure. MS Data Science, Stony Brook University. Patent holder. IEEE-published researcher.",
  og: {
    title: "Sethuram Gautham Rajakumar — Portfolio",
    type: "website",
    url: "https://sethuram.netlify.app/",
  },
};

//Home Page
const greeting = {
  title: "Sethuram Gautham",
  logo_name: "SethuramGautham",
  nickname: "AI/ML Engineer & Data Scientist",
  subTitle:
    "I build AI systems that actually ship — stateful agents that remember you, multi-agent pipelines that replace manual workflows, and local LLM infrastructure that keeps sensitive data on-prem. Spent 8 months at HGS Digital building production AI for Fortune 500 clients. Got a patent for a Tamil Braille reader I built during undergrad. MS in Data Science from Stony Brook, currently looking for full-time roles.",
  resumeLink:
    "https://drive.google.com/file/d/1GJb2Z2r6Y8m6HNBdy5fZ0B8tmv0b3V2I/view?usp=drive_link",
  portfolio_repository: "",
  githubProfile: "https://github.com/Sethuram2003",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/Sethuram2003",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/sethuramgautham/",
    fontAwesomeIcon: "fa-linkedin-in",
    backgroundColor: "#0077B5",
  },
  {
    name: "Gmail",
    link: "mailto:gauthamr2003@gmail.com",
    fontAwesomeIcon: "fa-google",
    backgroundColor: "#D14836",
  },
];

const skills = {
  data: [
    {
      title: "AI, LLMs & Agent Frameworks",
      fileName: "FullStackImg",
      skills: [
        "⚡ Built agents that actually remember things across sessions — using LangChain, LangGraph, and Letta (MemGPT). The agent learns your preferences over time instead of starting from zero every conversation.",
        "⚡ Set up multi-agent pipelines at HGS Digital where a router agent triages requests, specialized agents handle their domains, and an aggregation layer pieces it all together. Circuit breakers and retry logic so one agent failing doesn't kill the whole pipeline.",
        "⚡ Bridged Anthropic's MCP protocol with Ollama-hosted local models (Llama 3.1, Kimi-K2, Qwen) so legal firms and healthcare companies can use full LLM tool-use capabilities without sending a single byte to the cloud.",
        "⚡ RAG pipelines with LlamaIndex — experimented heavily with chunking strategies, embedding models, and vector stores (Pinecone, Weaviate, ChromaDB). Also built knowledge-graph-augmented retrieval with Neo4j and Microsoft GraphRAG for document-heavy enterprise use cases.",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "LangChain",
          fontAwesomeClassname: "simple-icons:langchain",
          style: {
            color: "#6C63FF",
          },
        },
        {
          skillName: "LangGraph",
          fontAwesomeClassname: "simple-icons:langchain",
          style: {
            color: "#1C3C3C",
          },
        },
        {
          skillName: "Ollama",
          fontAwesomeClassname: "simple-icons:ollama",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "Hugging Face",
          fontAwesomeClassname: "simple-icons:huggingface",
          style: {
            color: "#FFD21E",
          },
        },
        {
          skillName: "OpenAI",
          fontAwesomeClassname: "simple-icons:openai",
          style: {
            color: "#10A37F",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#2496ED",
          },
        },
        {
          skillName: "MCP",
          fontAwesomeClassname: "simple-icons:anthropic",
          style: {
            color: "#D4A27F",
          },
        },
      ],
    },
    {
      title: "Data Engineering & Big Data",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Built real-time data pipelines with Kafka, Airflow, and NiFi — stream processing, workflow orchestration, and ingestion for IoT and enterprise systems at scale.",
        "⚡ Big batch processing with Spark, Hadoop, and Hive — ETL, data lake management, and distributed computing when you need to crunch terabytes, not gigabytes.",
        "⚡ Put together a sensor data pipeline at undergrad that fed Kafka producers into a MySQL backend with Grafana dashboards on top. Used it for predictive maintenance on diesel generators.",
        "⚡ Comfortable with cloud data warehouses — AWS Glue, BigQuery, Snowflake, Redshift. Know when to use each one and when not to.",
      ],
      softwareSkills: [
        {
          skillName: "Apache Kafka",
          fontAwesomeClassname: "simple-icons:apachekafka",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Apache Spark",
          fontAwesomeClassname: "logos-apache-spark",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Apache Hadoop",
          fontAwesomeClassname: "simple-icons:apachehadoop",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Apache Airflow",
          fontAwesomeClassname: "simple-icons:apacheairflow",
          style: {
            backgroundColor: "transparent",
            color: "#017CEE",
          },
        },
        {
          skillName: "Apache Flink",
          fontAwesomeClassname: "simple-icons:apacheflink",
          style: {
            backgroundColor: "transparent",
            color: "#E6526F",
          },
        },
        {
          skillName: "Snowflake",
          fontAwesomeClassname: "simple-icons:snowflake",
          style: {
            backgroundColor: "transparent",
            color: "#29B5E8",
          },
        },
        {
          skillName: "Databricks",
          fontAwesomeClassname: "simple-icons:databricks",
          style: {
            backgroundColor: "transparent",
            color: "#FF3621",
          },
        },
      ],
    },
    {
      title: "Cloud Computing & DevOps",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Hands-on with AWS, Azure, and GCP — built and deployed on all three during my internship and coursework. AWS is where I'm strongest (10 badges).",
        "⚡ Deployed AI voice agents on Azure Cloud Functions that scale with call volume — no servers to manage, failover built in.",
        "⚡ Docker for everything — multi-stage builds, Docker Compose for multi-service setups, volume caching for big model files. Kubernetes for when things need to orchestrate.",
        "⚡ Databases: PostgreSQL, MySQL, MongoDB, Neo4j, Pinecone, ChromaDB. Pick the right one for the job instead of forcing one tool to do everything.",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#2496ED",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#4169E1",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Neo4j",
          fontAwesomeClassname: "simple-icons:neo4j",
          style: {
            color: "#008CC1",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#FFA116",
      },
      profileLink: "https://leetcode.com/u/Sethur2003/",
    },
    {
      siteName: "Credly",
      iconifyClassname: "simple-icons:credly",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.credly.com/users/sethuram-gautham-rajakumar",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/sethuramgautham",
    },
    {
      siteName: "Google Scholar",
      iconifyClassname: "simple-icons:googlescholar",
      style: {
        color: "#4285F4",
      },
      profileLink: "https://scholar.google.com/",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Stony Brook University",
      subtitle: "M.S. in Data Science",
      logo_path: "SBU_transparent.png",
      alt_name: "Stony Brook University",
      duration: "Aug 2024 — May 2026",
      descriptions: [
        "⚡ GPA: 3.67/4.0. Coursework covered the full spread — probability, statistical learning, data structures, cloud computing, big data systems, distributed computing. Heavy on theory but plenty of implementation work.",
        "⚡ Built AdaptiMind here — a context-aware AI agent using Llama 3.1 and Letta that actually remembers users across sessions. Got 90% better retrieval accuracy compared to stateless chatbots. The project that got me hooked on agent architectures.",
        "⚡ Active in the AI and Robotics communities on campus. Collaboration over competition — that's where the good ideas come from.",
      ],
      website_link: "https://www.stonybrook.edu/",
    },
    {
      title: "SSN College of Engineering",
      subtitle: "B.E. in Electrical and Electronics Engineering",
      logo_path: "SSN_transparent.png",
      alt_name: "SSN College of Engineering",
      duration: "Jun 2020 — May 2024",
      descriptions: [
        "⚡ GPA: 8.8/10.0. Electrical and Electronics Engineering — so my foundation is in circuits, signals, and math, not just software. Linear algebra, Laplace transforms, numerical methods, PDEs. The kind of math that makes ML theory click later.",
        "⚡ Built the Tamil Braille Character Recognition Device here — a Raspberry Pi with a custom CNN (TamilBrailleNet) that reads Braille and speaks it aloud. 97.45% accuracy on real student materials. Got a patent for it. This is the project that taught me you can ship real hardware-software products as a student.",
        "⚡ Published an IEEE paper on IoT-based diesel generator monitoring at ICNWC 2024. Also organized Robo Wars at the tech fest — because engineering school isn't just about the coursework.",
      ],
      website_link: "https://www.ssn.edu.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "CS50's Introduction to Artificial Intelligence with Python",
      subtitle: "- Harvard University (edX)",
      logo_path: "harvard_transparent.png",
      certificate_link:
        "https://certificates.cs50.io/a81582bf-5ff8-47a9-b3a1-0b5be24a91a2.pdf?size=letter",
      alt_name: "Harvard University",
      color_code: "#8C151599",
    },
    {
      title: "LLMs as Operating Systems: Agent Memory",
      subtitle: "- Sarah Wooders (Letta)",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://learn.deeplearning.ai/accomplishments/c414c634-819f-4670-aae0-21149336990c?usp=sharing",
      alt_name: "deeplearning.ai",
      color_code: "#0F000099",
    },
    {
      title: "Fuzzy Sets, Logic and Systems & Applications",
      subtitle: "- Nishchal Kumar Verma (NPTEL)",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/15bbsAgQ9NfsburW_CLcgTUijH3-W5SF3/view?usp=drive_link",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "AWS Educate — 10 Certification Badges",
      subtitle: "- Amazon Web Services",
      logo_path: "aws_transparent.png",
      certificate_link:
        "https://www.credly.com/users/sethuram-gautham-rajakumar",
      alt_name: "AWS",
      color_code: "#FF990099",
    },
    {
      title: "Data, Data, Everywhere",
      subtitle: "- Google",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/5EGN35V7Z6GL",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Arduino Platform and C Programming",
      subtitle: "- Ian Harris (UC Irvine)",
      logo_path: "UCI.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/PLD9GXN7W3KG",
      alt_name: "Arduino Platform and C Programming",
      color_code: "#FFFFFF",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Professional Roles & Internships",
  description:
    "8 months at HGS Digital building production AI for Fortune 500 clients — voice agents, multi-agent pipelines, a FinOps backend, and a social media sentiment analyzer. Also did a short stint at EQuad Engineering converting 2D images into 3D models for an industrial milling machine. Direct client-facing work from day one, not just ticket-chasing.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Professional Experience",
      work: true,
      experiences: [
        {
          title: "Associate Software Engineer — Intern",
          company: "HGS CX Technologies Inc. (HGS Digital)",
          company_url: "https://hgs.cx/",
          logo_path: "hgs_logo.png",
          duration: "May 2025 — Jan 2026 (8 Months)",
          location: "New York, New York, USA",
          description:
            "Owned full solution lifecycles — from architecture sketches through working prototypes to client demos. Built AI voice agents on Azure Cloud Functions (serverless, scales with call volume, failover built in). Set up multi-agent pipelines with n8n where a router triages, specialists do their thing, and an aggregation layer assembles the output. Also built a FastAPI backend for an AI FinOps platform (real-time cost tracking, anomaly detection) and a social media sentiment analyzer with async ingestion. Did pre-sales too — translated architecture diagrams into ROI stories for CTOs and VPs. Pioneered local LLM demos for enterprise clients who couldn't send data to the cloud. Tech: Azure Functions, Python, LangChain, LangGraph, n8n, FastAPI, MCP.",
          color: "#0879bf",
        },
        {
          title: "Associate Electrical Engineer — Intern",
          company: "EQuad Engineering Services Pvt. Ltd.",
          company_url: "http://equadservices.in/",
          logo_path: "equad.png",
          duration: "Jan 2023 — Feb 2023",
          location: "Chennai, Tamil Nadu, India",
          description:
            "Built a system that takes 2D images and turns them into 3D models using OpenCV and Open3D, then feeds them to an industrial milling machine for automated carving. Tuned the image-to-3D pipeline for better speed and precision — basically merged image processing with industrial automation. Short internship but it got me comfortable with hardware-software integration early on.",
          color: "#000000",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "These are the projects I keep coming back to. Some started as coursework, some as random experiments, a few turned into things people actually use. They span AI agents, local LLM infrastructure, audio processing, and accessibility tech. Each one taught me something I could not have learned from a tutorial.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications & Patents",
  description: "Peer-reviewed research and patented innovations.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "ieee-icnwc-2024-diesel-generator-iot",
      name: "Real Time Monitoring System of Diesel Generator using IoT",
      createdAt: "2024-01-01T00:00:00Z",
      description:
        "IEEE ICNWC 2024 — End-to-end IoT architecture from physical sensors to cloud dashboard for industrial generator management with predictive maintenance algorithms.",
      url: "https://ieeexplore.ieee.org/document/10537268",
    },
    {
      id: "patent-tamil-braille-recognition-device",
      name: "Tamil Braille Character Recognition Device",
      createdAt: "2023-07-01T00:00:00Z",
      description:
        "Patent awarded for novel hardware-software integrated system combining edge computing (Raspberry Pi) with custom hybrid CNN (TamilBrailleNet) for Tamil Braille recognition — 97.45% accuracy, 40% learning efficiency improvement.",
      url: "https://github.com/Sethuram2003",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "my_image_g.png",
    description:
      "Looking for full-time AI/ML engineering roles. Also open to research collaborations and interesting freelance work. Reach out on any platform — I usually reply within a day. Particularly interested in agent systems, local LLM infrastructure, and anything where AI meets the physical world.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I document my experiences in AI engineering, local LLM infrastructure, and technical knowledge sharing.",
    link: "https://sethuram.netlify.app/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "New York, United States",
    locality: "New York",
    country: "USA",
    region: "New York",
    postalCode: "10001",
    streetAddress: "New York, NY",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://www.google.com/maps/place/New+York,+NY",
  },
  phoneSection: {
    title: "Phone",
    subtitle: "+1 (934) 246-4678",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
